var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewTag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 8.23958C2 7.55186 2.60794 6.90625 3.44444 6.90625H20.5556C21.3921 6.90625 22 7.55186 22 8.23958V17.5729C22 18.2606 21.3921 18.9062 20.5556 18.9062H3.44444C2.60794 18.9062 2 18.2606 2 17.5729V8.23958ZM3.44444 4.90625C1.59206 4.90625 0 6.36064 0 8.23958V17.5729C0 19.4519 1.59206 20.9062 3.44444 20.9062H20.5556C22.4079 20.9062 24 19.4519 24 17.5729V8.23958C24 6.36064 22.4079 4.90625 20.5556 4.90625H3.44444ZM5.58868 10.9062H4.5V14.9062H5.70965V12.7348L7.52411 14.9062H8.49183V10.9062H7.28219V13.0777L5.58868 10.9062ZM9.21829 10.9062H12.6053V11.8205H10.307V12.392H12.3634V13.3062H10.307V13.992H12.6053V14.9062H9.21829V10.9062ZM14.1776 10.9062H12.9679L14.4195 14.9062H15.3872L16.234 12.6205L17.0807 14.9062H18.0484L19.5 10.9062H18.2904L17.5646 13.192L16.7178 10.9062H15.7501L14.9033 13.192L14.1776 10.9062Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTag);
export default __webpack_public_path__ + "static/media/new-tag.fbcae5ec.svg";
export { ForwardRef as ReactComponent };